import { __extends } from "tslib";
import MultipleMaskBase from './base';
import { getMaskAttrs } from '../circle';
/**
 * @ignore
 * 圆形辅助框 Action
 */
var CircleMultiMask = /** @class */ (function (_super) {
    __extends(CircleMultiMask, _super);
    function CircleMultiMask() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shapeType = 'circle';
        _this.getMaskAttrs = getMaskAttrs;
        return _this;
    }
    return CircleMultiMask;
}(MultipleMaskBase));
export default CircleMultiMask;
//# sourceMappingURL=circle.js.map